import React, { Component } from 'react'
import cookie from 'react-cookies'

// STYLES
import styled from 'styled-components'
import Colors from '../../shared/colors'

import DocPt from '../../assets/docs/politicPT.pdf'
import DocEn from '../../assets/docs/politicEN.pdf'

export default class Cookies extends Component {
  render () {
    const t = this.props.t

    const setApproved = () => {
      cookie.save('approved', true)
      this.props.setApproved()
    }

    const formatDoc = () => {
      if (this.props.i18n.language === 'pt') {
        return DocPt
      } else if (this.props.i18n.language === 'en') {
        return DocEn
      } else {
        return DocEn
      }
    }

    return (
      <Wrapper>
        <Content>
          <Text>
            {t('Os cookies ajudam-nos a melhorar a sua experiência de navegação. Ao utilizar o portal Taste Portugal, concorda com a utilização de cookies.')}<a href={formatDoc()} target="_blank">{t('Ler mais')}</a>
          </Text>
          <Button onClick={setApproved}>
            {t('CONCORDO')}
          </Button>
        </Content>
      </Wrapper>
    )
  }
}

const Wrapper = styled.div `
    position: fixed;
    bottom: 0;
    z-index: 10000;
    width: 100%;
    background-color: ${Colors.primary};
`
const Content  = styled.div `
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 30px;
    padding-bottom: 30px;
`
const Text = styled.div `
    color: #FFF;
    text-align: center;
    margin-bottom: 20px;
    font-size: 14px;
    font-family: 'PT Sans';
    a {
        color: #FFF;
        font-weight: 600;
        text-decoration: underline;
        margin-left: 4px;
        font-family: 'PT Sans';
    }
`
const Button = styled.div `
    width: 100px;
    text-align: center;
    background-color: #FFF;
    color: ${Colors.primary};
    border-radius: 3px;
    padding: 10px 10px;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.3s ease;
    font-family: "PT Sans";
    margin-left: auto;
    margin-right: auto;
    font-size: 14px;
    font-family: 'PT Sans';
`



// WEBPACK FOOTER //
// ./src/components/cookies/cookies.component.js